import { Component, OnInit, ViewChild,TemplateRef } from "@angular/core";
import {
  FormGroup,
  Validators,
  FormBuilder,
  FormControl,
} from "@angular/forms";
import { AppService } from "../services/app.service";
import { SupportService } from "../services/support-service";
import { IMyDpOptions, IMyDateModel } from "mydatepicker";
import * as moment from "moment";
import { environment } from "../../environments/environment";
import { TypeaheadMatch } from "ngx-bootstrap/typeahead/typeahead-match.class";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";

interface CancelAppointment {
  machine: string;
  mac: string;
  fromDate: string;
  toDate: string;
  fromTime: string;
  toTime: string;
  code: string;
  reason: string;
  firstName: string;
  lastName: string;
  patientId: string;
}
const days = [
  { id: 1, name: "monDay", value: "Monday" },
  { id: 1, name: "tueDay", value: "Tuesday" },
  { id: 1, name: "wedDay", value: "Wednesday" },
  { id: 1, name: "thuDay", value: "Thursday" },
  { id: 1, name: "friDay", value: "Friday" },
  { id: 1, name: "satDay", value: "Saturday" },
  { id: 1, name: "sunDay", value: "Sunday" },
];
@Component({
  selector: "app-cancel-appointments",
  templateUrl: "./cancel-appointments.component.html",
})
export class CancelAppointmentsComponent implements OnInit {
  cancelByMachine: FormGroup;
  cancelByDate: FormGroup;
  cancelByTime: FormGroup;
  cancelByPatients: FormGroup;
  rowsDataByMachine: any = [];
  rowsDataByDate: any = [];
  rowsDataByTime: any = [];
  rowsDataPatients: any = [];
  columnDataMachine: any = [];
  columnDataByDate: any = [];
  columnDataTime: any = [];
  columnDataPatients: any = [];
  totalItemsByMachine: any;
  totalItemsByDate: any;
  totalItemsByTime: any;
  totalItemsPatients: any;
  maxSizeItemByMachine: any;
  maxSizeItemByDate: any;
  maxSizeItemByTime: any;
  maxSizeItemPatients: any;
  currentPageByMachine: any;
  currentPageByDate: any;
  currentPageByTime: any;
  currentPagePatients: any;
  machineData: any = [];
  examByMac: any = [];
  examByMac1: any = [];
  fromTime: any = [];
  toTime: any = [];
  cFromTime: any = [];
  cToTime: any = [];
  patientList: any = [];
  errorMessage: string;
  successMessage: string;
  tabCacheObj: any = {};
  currentTabId = 0;
  selectedPatientName: any;
  destroyComponent: any = {};
  fromHourslowValue = 0;
  workingHours: any = [];
  toHoursHighValue = 0;
  @ViewChild("cancelpopup") cancelpopup: TemplateRef<any>;

  public myDatePickerOptions1: IMyDpOptions = {
    dateFormat: "mmm d, yyyy",
    disableUntil: {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate() - 1,
    },
    showClearDateBtn: false,
    editableDateField: false,
    firstDayOfWeek: "su",
  };
  public myDatePickerOptions2: IMyDpOptions = {
    dateFormat: "mmm d, yyyy",
    disableUntil: { year: 0, month: 0, day: 0 },
    showClearDateBtn: false,
    editableDateField: false,
    firstDayOfWeek: "su",
  };
  constructor(
    private fb: FormBuilder,
    private api: AppService,
    private supportService: SupportService,
    private modalService: BsModalService,
  ) {}

  ngOnInit() {
    this.initialiazedForm();
    this.setValues();
  }
  private initialiazedForm() {
    this.cancelByMachine = this.fb.group({
      machine: ["", Validators.compose([Validators.required])],
      mac: ["", Validators.compose([Validators.required])],
      fromDate: ["", Validators.compose([Validators.required])],
      toDate: ["", Validators.compose([Validators.required])],
      fromTime: ["", Validators.compose([Validators.required])],
      toTime: ["", Validators.compose([Validators.required])],
      code: ["", Validators.compose([Validators.required])],
      reason: ["", Validators.compose([Validators.required])],
    });
    this.cancelByDate = this.fb.group({
      fromDate: ["", Validators.compose([Validators.required])],
      toDate: ["", Validators.compose([Validators.required])],
      code: ["", Validators.compose([Validators.required])],
      reason: ["", Validators.compose([Validators.required])],
    });
    this.cancelByTime = this.fb.group({
      machine: ["", Validators.compose([Validators.required])],
      mac: ["", Validators.compose([Validators.required])],
      fromDate: ["", Validators.compose([Validators.required])],
      fromTime: ["", Validators.compose([Validators.required])],
      toTime: ["", Validators.compose([Validators.required])],
      code: ["", Validators.compose([Validators.required])],
      reason: ["", Validators.compose([Validators.required])],
    });
    this.cancelByPatients = this.fb.group({
      fromDate: ["", Validators.compose([Validators.required])],
      firstName: ["", Validators.compose([Validators.required])],
      lastName: ["", Validators.compose([Validators.required])],
      code: ["", Validators.compose([Validators.required])],
      reason: ["", Validators.compose([Validators.required])],
      patientId: ["", Validators.compose([Validators.required])],
    });
  }
  private setValues() {
    this.getMachinesMetaData();
    this.getPatientList();
    this.viewTestCenter();
    this.controlChangedetection();
    this.cancelByMachine.controls["fromDate"].setValue(this.cDate);
    this.cancelByDate.controls["fromDate"].setValue(this.cDate);
    this.cancelByTime.controls["fromDate"].setValue(this.cDate);
    this.cancelByPatients.controls["fromDate"].setValue(this.cDate);
    this.tabCacheObj["tabId"] = {};
    this.tabCacheObj["tabId"]["1"] = {};
    this.tabCacheObj["tabId"]["2"] = {};
    this.tabCacheObj["tabId"]["3"] = {};
    this.tabCacheObj["tabId"]["4"] = {};
    this.maxSizeItemByMachine = 10;
    this.maxSizeItemByDate = 10;
    this.maxSizeItemByTime = 10;
    this.maxSizeItemPatients = 10;
    this.totalItemsByMachine = 10;
    this.totalItemsByDate = 10;
    this.totalItemsByTime = 10;
    this.totalItemsPatients = 10;
    this.currentPageByMachine = 1;
    this.currentPageByDate = 1;
    this.currentPageByTime = 1;
    this.currentPagePatients = 1;
    this.currentTabId = 1;
    this.setTabCacheObj();
    this.getTimes();
    this.getRowsAndColumns();
  }
  private cDate() {
    const cDate = {
      date: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate(),
      },
    };
    return cDate;
  }

  tab1hide = true;
  tab2hide = true;
  tab3hide = true;
  tab4hide = true;
  hideHistory(type){
    if(type === 1){
      this.tab1hide = !this.tab1hide;
    }else if(type === 2){
      this.tab2hide = !this.tab2hide;
    }else if(type === 3){
      this.tab3hide = !this.tab3hide;
    }else if(type === 4){
      this.tab4hide = !this.tab4hide;
    }
  }

  private setTabCacheObj() {
    this.rowsDataByMachine = [
      { title: "Machine", sorting: true, name: "examName", dateFitler: false },
      {
        title: "Mac Number",
        sorting: true,
        name: "macName",
        dateFitler: false,
      },
      { title: "From Date", sorting: true, name: "fromDate", dateFitler: true },
      { title: "To Date", sorting: true, name: "to_date", dateFitler: true },
      {
        title: "From Time",
        sorting: true,
        name: "fromTime",
        dateFitler: false,
      },
      { title: "To Time", sorting: true, name: "toTime", dateFitler: false },
      { title: "Code", sorting: false, name: "cancelCode", dateFitler: false },
      {
        title: "Reason",
        sorting: false,
        name: "cancelReason",
        dateFitler: false,
      },
      {
        title: "Action",
        sorting: false,
        name: "action",
        dateFitler: false,
        action:true
      }
    ];
    this.rowsDataByDate = [
      { title: "From Date", sorting: true, name: "fromDate", dateFitler: true },
      { title: "To Date", sorting: true, name: "to_date", dateFitler: true },
      { title: "Code", sorting: false, name: "cancelCode", dateFitler: false },
      {
        title: "Reason",
        sorting: false,
        name: "cancelReason",
        dateFitler: false,
      },
      {
        title: "Action",
        sorting: false,
        name: "action",
        dateFitler: false,
        action:true
      }
    ];
    this.rowsDataByTime = [
      { title: "Machine", sorting: true, name: "examName", dateFitler: false },
      {
        title: "Date",
        sorting: true,
        name: "scheduledOnStr",
        dateFitler: true,
      },
      {
        title: "From Time",
        sorting: true,
        name: "fromTime",
        dateFitler: false,
      },
      { title: "To Time", sorting: true, name: "toTime", dateFitler: false },
      { title: "Code", sorting: false, name: "cancelCode", dateFitler: false },
      {
        title: "Reason",
        sorting: false,
        name: "cancelReason",
        dateFitler: false,
      },
      {
        title: "Action",
        sorting: false,
        name: "action",
        dateFitler: false,
        action:true
      }
    ];
    this.rowsDataPatients = [
      {
        title: "First Name",
        sorting: true,
        name: "patientFirstName",
        dateFitler: false,
      },
      {
        title: "Last Name",
        sorting: true,
        name: "patientLastName",
        dateFitler: false,
      },
      { title: "Date", sorting: true, name: "fromDate", dateFitler: true },
      { title: "Code", sorting: false, name: "cancelCode", dateFitler: false },
      {
        title: "Reason",
        sorting: false,
        name: "cancelReason",
        dateFitler: false,
      },
    ];
    this.tabCacheObj["tabId"][1]["row"] = {
      param1: "examName",
      param2: "macName",
      param3: "fromDate",
      param4: "to_date",
      param5: "fromTime",
      param6: "toTime",
      param7: "cancelCode",
      param8: "cancelReason",
    };
    this.tabCacheObj["tabId"][1]["pageOrder"] = {
      pageNumber: 1,
      pageRecord: this.maxSizeItemByMachine,
      patientType: "all",
      tcId: localStorage.getItem("testCenterId"),
      startDate: "",
      endDate: "",
      sortColumn: "",
      sortType: "",
      search: "",
      type: this.currentTabId,
    };
    this.tabCacheObj["tabId"][2]["row"] = {
      param1: "fromDate",
      param2: "to_date",
      param3: "cancelCode",
      param4: "cancelReason",
    };
    this.tabCacheObj["tabId"][2]["pageOrder"] = {
      pageNumber: 1,
      pageRecord: this.maxSizeItemByDate,
      patientType: "all",
      tcId: localStorage.getItem("testCenterId"),
      startDate: "",
      endDate: "",
      sortColumn: "",
      sortType: "",
    };
    this.tabCacheObj["tabId"][3]["row"] = {
      param1: "examName",
      param2: "scheduledOnStr",
      param3: "fromTime",
      param4: "toTime",
      param5: "cancelCode",
      param6: "cancelReason",
    };
    this.tabCacheObj["tabId"][3]["pageOrder"] = {
      pageNumber: 1,
      pageRecord: this.maxSizeItemByTime,
      patientType: "all",
      tcId: localStorage.getItem("testCenterId"),
      startDate: "",
      endDate: "",
      sortColumn: "",
      sortType: "",
      search: "",
      type: this.currentTabId,
    };
    this.tabCacheObj["tabId"][4]["row"] = {
      param1: "patientFirstName",
      param2: "patientLastName",
      param3: "fromDate",
      param4: "cancelCode",
      param5: "cancelReason",
    };
    this.tabCacheObj["tabId"][4]["pageOrder"] = {
      pageNumber: 1,
      pageRecord: this.maxSizeItemPatients,
      patientType: "all",
      tcId: localStorage.getItem("testCenterId"),
      startDate: "",
      endDate: "",
      sortColumn: "",
      sortType: "",
      search: "",
      type: this.currentTabId,
    };
  }
  private getMachinesMetaData() {
    this.api.getAllExamswithoutMRAandCTA().subscribe((res: any) => {
      if (res && res.entity && 0 < res.entity.length) {
        this.machineData = [];
        if (res && res["status"] && res["status"]["status"] == 200) {
          this.machineData = res["entity"];
          if (this.machineData.length > 0) {
            for (let index = 0; index < this.machineData.length; index++) {
              if (this.machineData[index].id == 1) {
                this.machineData[index].examsname = "MRI/MRA";
              } else if (this.machineData[index].id == 3) {
                this.machineData[index].examsname = "CTS/CTA";
              } else {
                this.machineData[index].examsname = this.machineData[index].examshortname;
              }
            }
          }

          console.log(this.machineData);
        } else {
          this.machineData = [];
        }
      }
    });
  }
  private controlChangedetection() {
    this.cancelByMachine.controls["machine"].valueChanges.subscribe(
      (value: any) => {
        if (value) {
          this.getFilterMachineById(parseInt(value));
        }
      }
    );
    this.cancelByTime.controls["machine"].valueChanges.subscribe(
      (value: any) => {
        if (value) {
          this.getFilterMachineById(parseInt(value));
        }
      }
    );
  }

  modalRef: BsModalRef;
  config = {
    ignoreBackdropClick: true,
  };

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign(this.config, { class: "popup-center" })
    );
  }

  popuptype:any;
  askCancelPopup(type){
    if(type){
      this.popuptype = type;
      this.openModal(this.cancelpopup);
    }
  }

  triggerPopup(){
    this.submit(this.popuptype);
  }

  private getTimes() {
    this.fromTime = environment.initialTimeNewObject;
    this.toTime = environment.initialTimeNewObject;
    this.cFromTime = environment.initialTimeNewObject;
    this.cToTime = environment.initialTimeNewObject;
  }
  private getFilterMachineById(id) {
    let machineId = 0;
    this.machineData.forEach((obj) => {
      if (obj && obj.id === id) {
        machineId = obj.id;
      }
    });
    if (machineId) {
      this.getMachinesByExamId(machineId);
    }
  }
  private getMachinesByExamId(machineId) {
    const param: any = {};
    param["tcId"] = localStorage.getItem("testCenterId");
    param["examId"] = machineId;
    this.api.getAllMachineByExamId(param).subscribe((res: any) => {
      if (res && res.entity && 0 < res.entity.length) {
        if (this.currentTabId === 1) {
          this.examByMac = res.entity;
          this.cancelByMachine.controls["mac"].setValue(res.entity[0].id);
        } else if (this.currentTabId === 3) {
          this.examByMac1 = res.entity;
          this.cancelByTime.controls["mac"].setValue(res.entity[0].id);
        }
        // debugger;
      }
    });
  }

  checkDate(str) {
    console.log(str.toString().length);
    const data = str;
    if (data.toString().length == 1) {
      return "0" + data;
    } else {
      return data;
    }
  }

  onInputFieldChanged(event: IMyDateModel, str: string) {
    if (event && event.date && str === "fromDateStr") {
      const copy: IMyDpOptions = this.getCopyOfEndDateOptions2();

      const today = new Date(event.jsdate);
      const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);

      copy.disableUntil = {
        day: this.checkDate(yesterday.getDate()),
        month: this.checkDate(yesterday.getMonth() + 1),
        year: yesterday.getFullYear(),
      };
      this.myDatePickerOptions2 = copy;
      if (this.currentTabId === 1) {
        this.cancelByMachine.controls["toDate"].setValue("");
      } else if (this.currentTabId === 2) {
        this.cancelByDate.controls["toDate"].setValue("");
      } else if (this.currentTabId === 3) {
        this.cancelByTime.controls["toDate"].setValue("");
      }
    }
  }
  private getCopyOfEndDateOptions2(): IMyDpOptions {
    return JSON.parse(JSON.stringify(this.myDatePickerOptions2));
  }
  submit(tab) {
    let check = false;
    let controlsObj: any;
    let typeId: any;
    if (tab === "tab1") {
      controlsObj = this.cancelByMachine;
      typeId = 1;
    } else if (tab === "tab2") {
      controlsObj = this.cancelByDate;
      typeId = 2;
    } else if (tab === "tab3") {
      controlsObj = this.cancelByTime;
      typeId = 3;
    } else if (tab === "tab4") {
      controlsObj = this.cancelByPatients;
      typeId = 4;
    }
    console.log(controlsObj);
    Object.keys(controlsObj.controls).forEach((key, i) => {
      const checkValidation = controlsObj.controls[key].valid;
      if (!checkValidation) {
        console.log(key);
        check = true;
      }
    });
    if (check) {
      this.errorMessage = "Please fill all the fields.";
      setTimeout(() => {
        this.errorMessage = "";
      }, 5000);
      this.modalRef.hide();
      return null;
    }
    const param: any = {};
    const cancelByMachineValue: CancelAppointment = controlsObj.value;
    param["examId"] =
      cancelByMachineValue.machine && cancelByMachineValue.machine !== ""
        ? cancelByMachineValue.machine
        : "";
    param["macId"] =
      cancelByMachineValue.mac && cancelByMachineValue.mac !== ""
        ? cancelByMachineValue.mac
        : "";
    param["fromDate"] =
      cancelByMachineValue.fromDate && cancelByMachineValue.fromDate !== ""
        ? moment(
            new Date(
              cancelByMachineValue.fromDate["date"]["year"],
              cancelByMachineValue.fromDate["date"]["month"] - 1,
              cancelByMachineValue.fromDate["date"]["day"]
            )
          ).format("YYYY-MM-DD")
        : "";
    param["toDate"] =
      cancelByMachineValue.toDate && cancelByMachineValue.toDate !== ""
        ? moment(
            new Date(
              cancelByMachineValue.toDate["date"]["year"],
              cancelByMachineValue.toDate["date"]["month"] - 1,
              cancelByMachineValue.toDate["date"]["day"]
            )
          ).format("YYYY-MM-DD")
        : "";
    param["fromTime"] =
      cancelByMachineValue.fromTime && cancelByMachineValue.fromTime !== ""
        ? this.convertTime12to24(
            this.getFilterTimeById(cancelByMachineValue.fromTime, this.fromTime)
          ) + ":00"
        : "";
    param["toTime"] =
      cancelByMachineValue.toTime && cancelByMachineValue.toTime !== ""
        ? this.convertTime12to24(
            this.getFilterTimeById(cancelByMachineValue.toTime, this.toTime)
          ) + ":00"
        : "";
    param["cancelCode"] =
      cancelByMachineValue.code && cancelByMachineValue.code !== ""
        ? cancelByMachineValue.code
        : "";
    param["cancelReason"] =
      cancelByMachineValue.reason && cancelByMachineValue.reason !== ""
        ? cancelByMachineValue.reason
        : "";
    if (typeId === 4) {
      param["firstName"] =
        cancelByMachineValue.code && cancelByMachineValue.code !== ""
          ? cancelByMachineValue.code
          : "";
      param["lastName"] =
        cancelByMachineValue.reason && cancelByMachineValue.reason !== ""
          ? cancelByMachineValue.reason
          : "";
      param["patientId"] =
        cancelByMachineValue.patientId && cancelByMachineValue.patientId !== ""
          ? cancelByMachineValue.patientId
          : "";
      param["scheduledOnStr"] = param.fromDate;
    }
    if (typeId === 3) {
      param["scheduledOnStr"] = param.fromDate;
    }
    param["cancelType"] = typeId;
    
    (param["testCenterId"] = localStorage.getItem("testCenterId")),
      this.api
        .cancelScheduleAppointmentByMachine(param)
        .subscribe((res: any) => {
          this.modalRef.hide();
          if (res && !res.entity && res.status.status !== 200) {
            if (res.status.status == 229) {
              this.errorMessage = "Please enter valid code";
            }
            if (res.status.status == 204) {
              this.errorMessage = "No schedule available to cancel";
            }
            setTimeout(() => {
              this.errorMessage = "";
            }, 5000);
            return null;
          }
          this.successMessage = "Successfully cancelled";
          setTimeout(() => {
            this.successMessage = "";
          }, 5000);
          this.setCache();
          this.getRowsAndColumns();
        });
  }
  private getFilterTimeById(id, time) {
    let machineId;
    time.forEach((obj) => {
      if (obj && obj.key === id) {
        machineId = obj.value;
      }
    });
    return machineId;
  }
  tabSelect(activeTab) {
    if (activeTab === "tab1") {
      this.currentTabId = 1;
    } else if (activeTab === "tab2") {
      this.currentTabId = 2;
    } else if (activeTab === "tab3") {
      this.currentTabId = 3;
    } else if (activeTab === "tab4") {
      this.currentTabId = 4;
    }
    this.getRowsAndColumns();
  }
  private getRowsAndColumns() {
    const tabId =
      this.tabCacheObj && this.tabCacheObj["tabId"]
        ? this.tabCacheObj["tabId"]
        : "";
    // debugger
    console.log(this.currentTabId);

    if (!this.currentTabId) {
      return null;
    }
    switch (this.currentTabId) {
      case 1:
        this.tabCacheObj["tabId"][this.currentTabId]["pageOrder"][
          "type"
        ] = this.currentTabId;
        this.checkTabIdInitialize();
        break;
      case 2:
        this.tabCacheObj["tabId"][this.currentTabId]["pageOrder"][
          "type"
        ] = this.currentTabId;
        this.checkTabIdInitialize();
        break;
      case 3:
        this.tabCacheObj["tabId"][this.currentTabId]["pageOrder"][
          "type"
        ] = this.currentTabId;
        this.checkTabIdInitialize();
        break;
      case 4:
        this.tabCacheObj["tabId"][this.currentTabId]["pageOrder"][
          "type"
        ] = this.currentTabId;
        this.checkTabIdInitialize();
        break;
    }
  }

  private checkTabIdInitialize() {
    this.generate();
    this.getPatientList();
    this.getColumnOrder();
  }

  private getColumnData(param?, blur?) {
    this.api.getIcscheduleCancel(param).subscribe(
      (res: any) => {
        this.setColumns(0, this.columnDataMachine);
        if (blur && blur === "blur") {
          this.tabCacheObj["tabId"][this.currentTabId]["currentPage"] = 1;
          this.currentPageByMachine = 1;
          this.currentPageByDate = 1;
          this.currentPageByTime = 1;
          this.currentPagePatients = 1;
        }
        if (res && res.entity) {
          this.tabCacheObj["tabId"][this.currentTabId]["totalItems"] =
            res["count"];
          this.totalItemsByMachine = res["count"];
          this.totalItemsByDate = res["count"];
          this.totalItemsByTime = res["count"];
          this.totalItemsPatients = res["count"];
          const columns = [];
          res.entity.forEach((obj) => {
            var that = this;
            const param = this.getParamData(obj,that.currentTabId);
            columns.push(param);
          });
          // debugger;
          this.setColumns(this.currentTabId, columns);
        }
      },
      (err) => {
        if (err.error.error === "invalid_token") {
          this.api.sessionOut(err);
        }
      }
    );
  }
  private setColumns(id, columns) {
    if (id === 1) {
      this.columnDataMachine = columns;
    } else if (id === 2) {
      this.columnDataByDate = columns;
    } else if (id === 3) {
      this.columnDataTime = columns;
    } else if (id === 4) {
      this.columnDataPatients = columns;
    } else {
      this.columnDataMachine = [];
      this.columnDataByDate = [];
      this.columnDataTime = [];
      this.columnDataPatients = [];
    }
  }
  private getParamData(obj,tab) {
    const param: any = {};
    console.log(obj);
    
    Object.keys(this.tabCacheObj["tabId"][this.currentTabId]["row"]).forEach(
      (key, i) => {
        i = i + 1;
        param["param" + i] =
          obj[this.tabCacheObj["tabId"][this.currentTabId]["row"]["param" + i]];
          if(tab === 1){
            if(i === 5 || i === 6){
              param["param" + i] = moment(obj[this.tabCacheObj["tabId"][this.currentTabId]["row"]["param" + i]], ["HH:mm",]).format("hh:mm A");
            }
            param["param" + 9] = obj.historyId;
          }else if(tab === 3){
            if(i === 3 || i === 4){
              param["param" + i] = moment(obj[this.tabCacheObj["tabId"][this.currentTabId]["row"]["param" + i]], ["HH:mm",]).format("hh:mm A");
            }
            param["param" + 9] = obj.historyId;
          }else if(tab === 2){
            param["param" + 9] = obj.historyId;
          }
      }
    );
    return param;
  }
  private getColumnOrder() {
    this.destroyComponent[
      "support"
    ] = this.supportService.gridSortingHeader.subscribe((result: any) => {
      if (result && (result["name"] || result["order"])) {
        this.tabCacheObj["tabId"][this.currentTabId]["pageOrder"][
          "sortColumn"
        ] = result["name"];
        this.tabCacheObj["tabId"][this.currentTabId]["pageOrder"]["sortType"] =
          result["order"];
        this.getColumnData(
          this.tabCacheObj["tabId"][this.currentTabId]["pageOrder"]
        );
      }
    });
  }
  ngOnDestroy() {
    Object.keys(this.destroyComponent).forEach((key, i) => {
      if (this.destroyComponent[key]) {
        this.destroyComponent[key].unsubscribe();
      }
    });
  }
  pageChanged(event) {
    if (this.currentTabId === 1) {
      this.currentPageByMachine = event.page;
    } else if (this.currentTabId === 2) {
      this.currentPageByDate = event.page;
    } else if (this.currentTabId === 3) {
      this.currentPageByTime = event.page;
    } else if (this.currentTabId === 4) {
      this.currentPagePatients = event.page;
    }
    this.tabCacheObj["tabId"][this.currentTabId]["pageOrder"]["pageNumber"] =
      event.page;
    this.getColumnData(
      this.tabCacheObj["tabId"][this.currentTabId]["pageOrder"]
    );
  }
  generate() {
    this.getColumnData(
      this.tabCacheObj["tabId"][this.currentTabId]["pageOrder"]
    );
  }
  blurOnChange(ev) {
    if (ev) {
      this.tabCacheObj["tabId"][this.currentTabId]["pageOrder"]["search"] = ev;
      this.tabCacheObj["tabId"][this.currentTabId]["pageOrder"][
        "pageNumber"
      ] = 1;
      this.getColumnData(
        this.tabCacheObj["tabId"][this.currentTabId]["pageOrder"],
        "blur"
      );
    } else {
      this.tabCacheObj["tabId"][this.currentTabId]["pageOrder"]["search"] = "";
      this.tabCacheObj["tabId"][this.currentTabId]["pageOrder"][
        "pageNumber"
      ] = 1;
      this.getColumnData(
        this.tabCacheObj["tabId"][this.currentTabId]["pageOrder"],
        "blur"
      );
    }
  }
  convertTime12to24 = (time12h) => {
    const [time, modifier] = time12h.split(" ");
    let [hours, minutes] = time.split(":");
    // const today = new Date();
    // const offset = (today.getTimezoneOffset()/60);
    const min = minutes;
    minutes = min;
    if (hours === "12") {
      hours = "00";
    }
    if (modifier === "PM") {
      hours = parseInt(hours, 10) + 12;
    }
    // hours = parseInt(hours, 10) + offset;
    // let offsetMinutes = hours % 1;
    // offsetMinutes = offsetMinutes * 60;
    // hours = Math.trunc(hours);
    // minutes = parseInt(minutes) + offsetMinutes;
    // if (60 <= minutes) {
    //   hours = hours + 1;
    //   minutes = minutes % 60;
    //   hours = 24 < hours ? hours - 24 : hours;
    //   hours = 24 > hours ? 24 - hours : hours;
    //   hours = hours < 9 ? '0' + hours : hours;
    //   minutes = minutes < 9 ? '0' + minutes : minutes;
    // }
    return `${hours}:${minutes}`;
  };
  checkTimeValidation(ev) {
    let val = ev.target.value;
    const newFromTime = [];
    if (val) {
      val = parseFloat(val);
      this.fromTime.forEach((obj) => {
        if (obj && obj.key && val < parseFloat(obj.key)) {
          newFromTime.push(obj);
        }
      });
    }
    if (newFromTime.length === 0) {
      newFromTime.push(this.fromTime[this.fromTime.length - 1]);
    }
    if (this.currentTabId === 1) {
      this.toTime = newFromTime;
      this.cancelByMachine.controls["toTime"].setValue(this.toTime[0].key);
      this.cancelByMachine.updateValueAndValidity();
    } else if (this.currentTabId === 3) {
      this.cToTime = newFromTime;
      this.cancelByTime.controls["toTime"].setValue(this.cToTime[0].key);
      this.cancelByTime.updateValueAndValidity();
    }
  }
  getPatientList() {
    this.api.getAllPatientByType().subscribe((patient: any) => {
      this.patientList = [];
      if (patient.status.status === 200) {
        this.patientList = patient.entity;
        if (this.patientList.length > 0) {
          this.patientList.forEach((patientData) => {
            patientData.username = patientData.firstName+' '+patientData.lastName;
          });
        }
      }
    });
  }
  onSelectPatient(event: TypeaheadMatch): void {
    this.cancelByPatients.controls["firstName"].setValue(event.item.firstName);
    this.cancelByPatients.controls["lastName"].setValue(event.item.lastName);
    this.cancelByPatients.controls["patientId"].setValue(event.item.id);
    this.selectedPatientName = event.item.firstName;
  }
  private setCache() {
    if (this.currentTabId === 1) {
      this.cancelByMachine.reset();
      this.initialiazedForm();
      this.tabCacheObj["tabId"][1]["pageOrder"] = {
        pageNumber: 1,
        pageRecord: this.maxSizeItemByMachine,
        patientType: "all",
        tcId: localStorage.getItem("testCenterId"),
        startDate: "",
        endDate: "",
        sortColumn: "",
        sortType: "",
        search: "",
        type: this.currentTabId,
      };
      this.currentPageByMachine = 1;
      this.cancelByMachine.controls["fromDate"].setValue(this.cDate);
    } else if (this.currentTabId === 2) {
      this.cancelByDate.reset();
      this.initialiazedForm();
      this.tabCacheObj["tabId"][2]["pageOrder"] = {
        pageNumber: 1,
        pageRecord: this.maxSizeItemByDate,
        patientType: "all",
        tcId: localStorage.getItem("testCenterId"),
        startDate: "",
        endDate: "",
        sortColumn: "",
        sortType: "",
      };
      this.currentPageByDate = 1;
      this.cancelByDate.controls["fromDate"].setValue(this.cDate);
    } else if (this.currentTabId === 3) {
      this.cancelByTime.reset();
      this.initialiazedForm();
      this.tabCacheObj["tabId"][3]["pageOrder"] = {
        pageNumber: 1,
        pageRecord: this.maxSizeItemByTime,
        patientType: "all",
        tcId: localStorage.getItem("testCenterId"),
        startDate: "",
        endDate: "",
        sortColumn: "",
        sortType: "",
        search: "",
        type: this.currentTabId,
      };
      this.currentPageByTime = 1;
      this.cancelByTime.controls["fromDate"].setValue(this.cDate);
    } else if (this.currentTabId === 4) {
      this.cancelByMachine.reset();
      this.initialiazedForm();
      this.tabCacheObj["tabId"][4]["pageOrder"] = {
        pageNumber: 1,
        pageRecord: this.maxSizeItemPatients,
        patientType: "all",
        tcId: localStorage.getItem("testCenterId"),
        startDate: "",
        endDate: "",
        sortColumn: "",
        sortType: "",
        search: "",
        type: this.currentTabId,
      };
      this.currentPagePatients = 1;
      this.cancelByPatients.controls["fromDate"].setValue(this.cDate);
      this.selectedPatientName = "";
    }
  }
  viewTestCenter() {
    this.api.viewtestcenter().subscribe(
      (res) => {
        if (
          res &&
          res["status"] &&
          res["status"] &&
          res["status"]["status"] === 200
        ) {
          if (res["entity"]) {
            const workingHours = res["entity"]["workingHours"];
            this.setCalendarTime(workingHours);
          }
        }
      },
      (err) => {
        this.api.sessionOut(err);
      }
    );
  }
  setCalendarTime(workhours) {
    const getDate = moment(new Date()).format("dddd");
    if (workhours.length > 0) {
      days.forEach((day) => {
        if (day.value === getDate) {
          workhours.forEach((work) => {
            if (work.workHourType === "work") {
              this.convertFromTimeformat(work.fromHour);
              this.convertToTimeformat(work.toHour);
            }
          });
        }
      });
    }
  }

  private parseTimeToFloat(str) {
    const [timePart, AMPM] = str.trim().split(" ");
    const [hourStr, minuteStr] = timePart.split(":");
    let hours = Number(hourStr);
    const minutes = Number(minuteStr);
    if (AMPM === "PM" && hours < 12) hours = hours + 12;
    if (AMPM === "AM" && hours === 12) hours = hours - 12;
    let sHours = hours.toString();
    let sMinutes = minutes.toString();
    if (hours < 10) sHours = "0" + sHours;
    if (minutes < 10) sMinutes = "0" + sMinutes;
    return parseFloat(sHours + "." + sMinutes);
  }

  convertFromTimeformat(str) {
    const result = this.parseTimeToFloat(str);
    if (this.fromHourslowValue == 0) {
      this.fromHourslowValue = result;
    }
    if (result <= this.fromHourslowValue) {
      this.fromHourslowValue = result;
    }
  }

  convertToTimeformat(str) {
    const result = this.parseTimeToFloat(str);
    if (this.toHoursHighValue == 0) {
      this.toHoursHighValue = result;
    }
    if (result >= this.toHoursHighValue) {
      this.toHoursHighValue = result;
    }
  }
}
